export const ReasoningApi = Symbol.for('ReasoningApi');
